// LICENSE_CODE ZON
'use strict'; /*jslint node:true, es6:true, react:true*/
var define;
var is_node = typeof module=='object' && module.exports;
if (is_node)
    define = require('../../../util/require_node.js').define(module, '..');
else
    define = self.define;
define(['react',
    '/util/url.js', '/www/hola/pub/ui/trustpilot_link.tsx',
    '/www/hola/pub/lib/screen_util.ts',
    '/www/hola/pub/ui/install_util.js', '/www/hola/pub/ui/img_url.ts',
    'hola_opt', '/util/etask.js', '/util/escape.js',
    'classnames', 'zutil',
    '/svc/account/pub/membership.js', '/www/hola/pub/plus_util.js',
    '/www/hola/pub/eec.js', '/www/hola/pub/gtm.ts',
    '/util/zerr.js', '/util/hash.js',
    '/www/hola/pub/plus_ui.js', '/www/hola/pub/install_util.js',
    '/www/hola/pub/util.js', '/util/country.js', 'react-router-dom',
    '/www/hola/pub/pages_dict.js', '/www/hola/pub/plans_util.js',
    'react-i18next',
    '/www/hola/pub/experiment_init',
    '/www/hola/pub/experiment_util',
    '/www/hola/pub/ui/navbar/navbar_logo.js', '/www/hola/pub/plus/plans.js',
    '/www/hola/pub/lib/slider.tsx',
    '/www/hola/pub/settings_ctx.tsx',
    '/www/hola/pub/plus/payment_progress.tsx',
    '/www/hola/pub/lib/tooltip.js',
    '/www/hola/pub/plus/currency_select.tsx',
    '/www/hola/pub/lib/use_qs.ts', '/www/hola/pub/plus/plan_banner.tsx',
    '/www/hola/pub/ui/browser/br_footer.tsx',
    // imports only
    '/www/hola/pub/css/join_n.less'],
    (React, zurl, {Trustpilot_link}, {get_width}, {_start_install}, {img_url}, hopt, etask, zescape,
    cn, _, membership, plus_util, eec, gtm, zerr, zhash, plus_ui,
    iutil, www_util, zcountry, RRD, pages_dict,
    plans_util, react_i18n,
    experiment_init, experiment_util, {Navbar_logo}, {Plus_plans},
    {Slider}, {Settings_context}, {Payment_progress},
     {Tooltip}, {Currency_select}, {use_qs_with_set},
    {Plan_banner}, {Br_footer})=>
    {
const {useState, useEffect, Fragment, useContext} = React;
const {useLocation} = RRD;
const {Trans: T, useTranslation} = react_i18n;
experiment_init = experiment_init.default;
experiment_util = experiment_util.default;
const E = {};

const qs_o = ()=>zurl.qs_parse(location.search.substr(1), {safe: true});
const N = 2;
const ref = qs_o().ref||'';

const perr = opt=>
    plus_util.perr({...opt, id: opt.id.replace(/^www_join1/, `www_join${N}`)});
const perr_hashes = {};
const perr_once = opt=>{
    const hash = ''+zhash.hash_string(zerr.json(opt));
    if (perr_hashes[hash])
        return;
    perr_hashes[hash] = true;
    return perr(opt);
};
const plan_to_url = (plan, opt = {})=>plan
    && (opt.ultra ? plan.id : plan.period.toLowerCase().replace(' ', ''));
const get_url_plan = params=>{
    params = params||qs_o();
    if (plans_util.get_coupon_flow()=='coupon')
        return {id: 'coupon', price: 0};
    let plan, period;
    if (params.plan_id)
    {
        plan = plans_util.get_plans_info_obj({id: params.plan_id});
        if (plan)
            return plans_util.get_discount_plan(plan) || plan;
        perr_once({id: 'www_join1_plan_not_found', info: params});
    }
    if (!plan && params.plan)
        period = plus_util.parse_plan_period(params.plan);
    if (!period && params.plan_id)
        period = plus_util.parse_plan_period(params.plan_id);
    if (period)
    {
        plan = plans_util.get_plans_info_obj({period});
        plan = plans_util.get_discount_plan(plan) || plan;
        if (!plan)
            perr_once({id: 'www_join1_plan_not_found', info: params});
        return plan;
    }
};
E.get_url_plan = get_url_plan;
const get_url_plan_or_default = (def, params)=>{
    const plan = get_url_plan(params);
    if (plan)
        return plan;
    return get_url_plan(def);
};
E.get_url_plan_or_default = get_url_plan_or_default;

const Free_period_label = ({plan, is_payment_slide})=>{
    const {free_period, id: plan_id} = plan||{};
    const {src} = {
        '1 M': {src: 'plus/free_for_month.png'},
    }[free_period]||{};
    const [img_src, set_img_src] = useState(src);
    const [show_label, set_show_label] = useState(false);
    useEffect(()=>{
        if (plan_id)
            set_img_src(src);
    }, [src, plan_id]);
    useEffect(()=>{
        set_show_label(img_src && is_payment_slide);
    }, [img_src, is_payment_slide]);
    return img_src ? <img src={img_url(img_src)} alt="free_period"
      className={cn('free_period_label label_appear', 'lazyload',
        !show_label && 'label_hidden')}/> : null;
};

const Header = ()=>{
    if (pages_dict.is_uninstall_page())
    {
        return <div className="header uninstall">
          <p>Special offer:</p>
          <h2><span>Save 47% </span>on Hola Premium</h2>
        </div>;
    }
    return <div className="header">
      <h2><T>Choose Your Plan</T></h2>
      <p><b><T>Unlimited super fast
        browsing</T></b></p>
    </div>;
};

const Select_plan = props=>{
    let {downloads, plans, set_plan, country, set_currency, cls,
      only_right_part} = props;
    const {theme} = useContext(Settings_context);
    const {pathname} = useLocation();
    plans = plans.slice();
    if (plans.length==0)
        return <Fragment></Fragment>;
    const {best} = plans_util.get_special_plans(plans);
    const {currency, currencies} = plus_util.get_currency_o(props.currency,
        best);
    const {renewal_price} = membership.get_price_plan(best, currency);
    const annual_promo = pages_dict.is_uninstall_page() ||
        pages_dict.is_annual_promo();
    const bogof_promo = pages_dict.is_bogof_promo();
    const is_afflp_ni = (qs_o().ref || '').indexOf('afflp_ni') > -1;
    const is_afflp_annual = (qs_o().ref || '').indexOf('afflp_annual') > -1;
    const is_new_tabs = pathname=='/premium' &&
        (is_afflp_ni || is_afflp_annual);
    const {layout} = qs_o();
    const condensed = layout=='condensed';
    return <div className={cn('select-plan', cls)}>
      {currencies.length>1
        && <Currency_select only_right_part={only_right_part}
          currency={currency} on_change={set_currency} currencies={currencies}
          cls={cn('currency_select_float_right',
          condensed && 'condensed_currency_select_float_right')}/>}
      {!only_right_part && <Header downloads={downloads} country={country}/>}
      <div className="container">
        {is_new_tabs ? <plus_ui.Plus_plans_tabs plans={plans}
          set_plan={set_plan} best={best} currency={currency}/> :
          <Plus_plans plans={plans} best={best} N={N} bogof={bogof_promo}
          set_plan={set_plan} short currency={currency}/>}
        <div className="money-back">
          <T i18nKey="30_day_moneyback_text.join_n"
            components={{span: <span className={cn(theme.P, theme.xs)}/>,
            b: <b/>, strong: <strong/>,
            a: <a href="/faq#refund-policy" target="_blank"
              rel="noopener noreferrer"/>}}/>
        </div>
        {annual_promo && <div className="renewal">
          <p className={theme.p2}>
            <sup>*</sup>After the initial period, you will be
            charged {zcountry.format_price(
                currency, renewal_price)} annual service fee until you
            cancel the subscription
          </p>
        </div>}
        {bogof_promo && <div className="renewal">
          <p className={theme.p2}>
            * After the initial 2 months period, you will be
            charged {zcountry.format_price(
                currency, best.price)} monthly service fee until you
            cancel the subscription
          </p>
        </div>}
      </div>
    </div>;
};

const Slide_select_plan = ({cls, cmp_props})=>{
    return <Select_plan key="select_plan" cls={cls} {...cmp_props}/>;
};

const Coupon_slide = ({cls, cmp_props})=>{
    const {email, coupon_flow, slide, go_back, show_back, on_continue} =
        cmp_props;
    return <div key="coupon" className={cls}>
        {!!show_back && <a className="back-button" onClick={go_back}>
          Back</a>}
        <plus_ui.Step_redeem email={email}
          slide_active={slide=='coupon'}
          hide_agree={coupon_flow!='coupon'}
          on_continue={coupon_flow!='coupon' && on_continue}/>
    </div>;
};
const Payment_slide = ({cls, cmp_props})=>{
    const {slide, plan} = cmp_props;
    const [method_chosen, set_method_chosen] = useState(false);
    const payment_step_cls = cn('container payment-container',
        method_chosen && 'method-chosen');
    return <div key="payment" className={cls}>
      <div className={payment_step_cls}>
        {plan && <plus_ui.Step_payment expand="cc" selected_plan={plan}
          slide_active={slide=='payment'} set_method_chosen={set_method_chosen}
          method_chosen={method_chosen} {...cmp_props}>
        </plus_ui.Step_payment>}
      </div>
    </div>;
};

const Slides = props=>{
    let {user, user_email, load_user, plan, api, set_api, api_loaded, go_back,
        on_continue, slide, set_plan, downloads, currency, country,
        coupon, set_currency, script_err, set_coupon,
        on_script_load_err, only_right_part, on_method_tab_change,
        on_vat_obj_change} = props;
    const {pathname} = useLocation();
    const [state, set_state] = useState({email: user_email,
        email_error: null});
    const [plans, set_plans] = useState([]);
    useEffect(()=>{
        perr({id: `www_join1_${slide}_show`});
    }, [slide]);
    const plans_version = plans_util.use_plans();
    useEffect(()=>{
        const plans_info = _.values(plans_util.get_plans_info(plans_util
            .get_plan_ids()));
        set_plans(plans_info);
        const {best} = plans_util.get_special_plans(plans_info||[]);
        const currency_o = plus_util.get_currency_o(currency, best);
        set_currency(currency_o.currency);
    }, [pathname, plans_version]);
    const set_email = email=>set_state(_st=>{
        email = `${email || ''}`.trim();
        return {..._st, email, email_error: null};
    });
    const set_email_err = email_error=>set_state(_st=>{
        return {..._st, email_error};
    });
    let {email, email_error} = state;
    const check_email = _email=>{
        if ((_email || email) && !user)
        {
            const err = plus_util.validate_email_syntax(_email||email);
            if (!err)
                return true;
            set_email_err(err);
            return false;
        }
        return true;
    };
    const coupon_flow = plans_util.get_coupon_flow();
    let show_back = slide=='account' && !coupon_flow || slide=='payment' &&
        (!coupon_flow || !user);
    const steps_cls = cn('steps');
    const cmp_props = {downloads, plan, plans, set_plan, country, set_coupon,
        coupon, currency, set_currency, user, slide, load_user, email_error,
        set_email_err, set_email, email, on_continue, check_email, coupon_flow,
        show_back, go_back, script_err, api, user_email, api_loaded, set_api,
        set_plans, on_script_load_err, only_right_part,
        on_method_tab_change, on_vat_obj_change};
    return <div className={steps_cls}>
      <Slider active={slide} items={[
        {id: 'select_plan', content: Slide_select_plan},
        {id: 'coupon', content: !!coupon_flow && Coupon_slide},
        {id: 'payment',
          content: coupon_flow!='coupon' && Payment_slide},
        ]} timeout={200} cmp_props={cmp_props} distance={150}
        on_end_animation={()=>window.scrollTo(0, 0)}/>
    </div>;
};

const Advantages = ({type, plan})=>{
    const {t} = useTranslation();
    const {theme} = useContext(Settings_context);
    let platforms = img_url('platforms/platforms_list.svg');
    if (get_width() < 768)
        platforms = img_url('platforms/platforms_list_mobile.svg');
    return <ul className={`advantages ${type}`}>
      <li className="unblock">
        <p className={theme.p2}><T>
          {type=='free' && 'Unblock 99.9% of websites'}
          {type=='plus' && 'Access more global content'}
          {type=='ultra' && (plan ? <b>Everything in Premium</b> :
              'Access more global content')}
        </T></p>
      </li>
      <li className="devices">
        <p className={theme.p2}>
          {t('connect_devices', {count: type=='ultra' ? 20 :
          type=='plus' ? 10 : 3})}
        </p>
      </li>
      <li className="streaming"><p className={theme.p2}><T>{type=='ultra' ?
        '4K' : type=='plus' ? 'HD' : 'SD'} Video streaming</T></p></li>
      <li className="servers"><p className={theme.p2}>{t(`${type=='ultra' ?
        'Ultra fast' : 'Super fast'} servers`)}</p></li>
      {type=='free' && <Fragment>
        <li><p className={theme.p2}>Free limited browsing time</p></li>
      </Fragment>}
      {(type=='plus' || type=='ultra' && !plan) && <Fragment>
        <li className="vpn_time"><p className={theme.p2}>
          <T>Unlimited usage</T></p></li>
      </Fragment>}
      {(type=='ultra' || type=='plus') && <li className="platforms">
        <p className={theme.p2}>Apps across all of your <Tooltip
          content={<img alt="platforms" src={platforms} className="lazyload"/>}
          cls_cn="platforms-tooltip">
          <span className={cn(theme.primary, 'platforms-tooltip-text')}>
            favorite platforms</span>
        </Tooltip></p>
      </li>}
      {(type=='ultra' || type=='plus') && <li className="smart_dns">
        <p className={theme.p2}>Smart DNS for TVs, Gaming Consoles</p></li>}
      {type=='ultra' && <li className="support"><p className={theme.p2}>
          24/7 Real person support</p></li>}
    </ul>;
};
E.Advantages = Advantages;

const start_install = (ctx, agree)=>{
    _start_install({ctx, agree,
        install_src: `join${N}`,
        skip: {choose_plan: true},
    }, ()=>perr({id: 'www_join1_start_install'}));
};

let install_ctx_et, install_ctx;
const init_install_ctx = ()=>{
    if (install_ctx)
        return;
    return install_ctx_et || etask(function*(){
        install_ctx_et = this;
        this.finally(()=>install_ctx_et = null);
        install_ctx = yield iutil.init_ctx({install_src: `join${N}`});
    });
};

const Summary_info = ({plan, currency})=>{
    const {theme} = useContext(Settings_context);
    const {pathname} = useLocation();
    const type = pathname=='/ultra' ? 'Ultra' : 'Premium';
    const price_o = membership.get_price_plan(plan, currency);
    const {regular_price, price, discount_percent} = price_o;
    const save_money = regular_price - price;
    return <div className={cn('payment_summary_info')}>
      <div className='payment_summary_row'>
        <p className={cn(theme.xs, theme.grey_2)}>Hola {type}</p>
        <p className={cn(theme.xs, theme.grey_2)}>
          {zcountry.format_price(currency, regular_price)}</p>
      </div>
      <div className='payment_summary_row'>
        <p className={cn(theme.xs, theme.grey_2, 'payment_flex_discount')}>
          Discount {discount_percent > 0 ? <span
            className='payment_discount_label'>{discount_percent}%
            saving</span> : ''}</p>
        <p className={cn(theme.xs, theme.grey_2)}>
          {zcountry.format_price(currency,
              save_money > 0 ? -save_money : 0)}</p>
      </div>
      <div className='payment_summary_line'></div>
      <div className='payment_summary_row'>
        <p className={cn(theme.xs, theme.grey_2)}><b>Order total</b></p>
        <p className={cn(theme.xs, theme.grey_2)}>
          {zcountry.format_price(currency, price)}</p>
      </div>
    </div>;
};

const Payment = ({opt, only_right_part})=>{
    const {theme} = useContext(Settings_context);
    const {pathname} = useLocation();
    const type = pathname=='/ultra' ? 'ultra' : 'plus';
    plans_util.use_plans();
    const plans = _.values(plans_util.get_plans_info(plans_util
        .get_plan_ids()));
    const best = _.min_by(plans, p=>p.month_price);
    const on_click_select = ()=>{
        if (opt.slide!='select_plan')
            opt.go_back();
    };
    const on_click_payment = ()=>{
        if (opt.slide!='payment')
            opt.set_plan(best);
    };
    const {plan} = opt;
    const new_uninstall = pages_dict.is_uninstall_page();
    const refund_page = ref=='refund' || ref=='refund_special_big_offer' ||
        ref=='refund_special_cta';
    const is_condensed = qs_o().layout=='condensed' && 'condensed';
    return <div className={cn(is_condensed ? 'condensed' : theme.container,
      'payment')}>
      {!is_condensed && <Payment_progress slide={opt.slide}
        on_click_select={on_click_select}
        on_click_payment={on_click_payment}/>}
      <section className={cn('payment-section',
        only_right_part && 'only_right_part')}>
        {!only_right_part && !is_condensed && <div className="payment-info">
          {new_uninstall ? <Fragment>
            <h3>
              Seems you are not happy with our free version…<br/>
              Try Hola Premium!
            </h3>
          </Fragment> : refund_page ? <Fragment>
            <p className="refund-text">
              <span>Don't worry! </span>
              After confirming the payment, we will process the <b>refund
              for your previous purchase</b> and you will receive it in the
              next 5-7 business days.
            </p>
          </Fragment> : <Fragment>
            <h3><T>Experience the full power of Hola</T></h3>
            <b className={theme.P}><T i18nKey="get_in_join"/> {type=='ultra' ?
              'Ultra' : 'Premium'}</b>
          </Fragment>}
          {plan && opt.currency && opt.slide=='payment'
            && <Summary_info {...opt}/>}
          <Advantages type={type}/>
          <Trustpilot_link/>
          {plan && opt.slide=='payment' && <Plan_banner plan_id={plan.id}/>}
        </div>}
        <div className="payment-steps"><Slides {...opt}
          only_right_part={only_right_part}/></div>
      </section>
      <Free_period_label plan={plan} is_payment_slide={opt.slide==='payment'}/>
    </div>;
};

E.Root = ({users_number, user_country, only_right_part, goto})=>{
    if (goto)
        console.log(goto);
    const {theme} = useContext(Settings_context);
    const [script_err, set_script_err] = useState({});
    const {pathname} = useLocation();
    let plan = get_url_plan();
    const version = plans_util.use_plans();
    const coupon_flow = plans_util.get_coupon_flow();
    const [state, set_state] = useState({
        user: null,
        api: plus_util.api,
        slide: plan ? coupon_flow ? 'coupon' : 'payment' : 'select_plan',
        plan_id: plan && plan.id,
        currency: hopt.user_currency,
        provider: undefined,
        vat_obj: undefined,
    });
    useEffect(()=>{
        let plan2 = get_url_plan();
        if (plan2 && state.plan_id!=plan2.id)
            set_state(v=>({...v, plan_id: plan2.id}));
    }, [version, state.plan_id]);
    let {api, user, api_loaded} = state;
    const {set_qs: set_url_params} = use_qs_with_set();
    const load_user = force=>etask(function*(){
        let _user = yield plus_util.login_get_user(force);
        let coupon = state.coupon;
        const new_state = {user: _user, api: plus_util.api,
            api_loaded: true};
        if (_user && _user.coupon && _user.coupon.type && (!coupon_flow
            || coupon_flow==_user.coupon.type))
        {
            new_state.coupon = coupon = _user.coupon._id;
            if (_user.coupon.currency)
                new_state.currency = _user.coupon.currency;
            if (coupon_flow=='promo_plan')
            {
                plans_util.set_fixed_plan_ids(['promo_y1', 'promo_y3']);
                if (ref && !ref.includes(_user.coupon.affiliate))
                    set_url_params({ref: _user.coupon.affiliate+ref});
            }
        }
        new_state.slide = !get_url_plan() ? 'select_plan' :
            coupon_flow && !coupon ? 'coupon' : 'payment';
        set_state(_state=>({..._state, ...new_state}));
        return _user;
    });
    const on_qs_change = ()=>{
        let _plan = get_url_plan();
        let plan_id = _plan && _plan.id;
        set_state(_state=>({..._state, slide: !plan_id ? 'select_plan' :
            coupon_flow && !_state.coupon ? 'coupon' : 'payment',
            plan_id: plan_id || _state.plan_id}));
    };
    const on_method_tab_change = (method, provider)=>{
        set_state(s=>({...s, provider}));
    };
    const on_vat_obj_change = vat_obj=>{
        set_state(s=>({...s, vat_obj}));
    };
    const checkout_redirect = ()=>{
        // XXX dmitriiz: do nothing, there was code for "old layout"
    };
    const on_script_load_err = ev=>{
        const src = _.get(ev, 'target.src')||'';
        const match = src.match(/(2pay\.js|bluesnap\.js|js\.stripe\.com|paypal\.com\/sdk\/js|pay\.google\.com)/);
        perr({id: 'www_premium_payment_script_load_err', info: {src}});
        if (match)
            set_script_err(errs=>({...errs, [match[1]]: true}));
    };
    useEffect(()=>{
        checkout_redirect();
        window.addEventListener('popstate', on_qs_change);
        return ()=>window.removeEventListener('popstate', on_qs_change);
    }, [state]);
    useEffect(()=>{
        document.addEventListener('click', event=>{
            const {id: click_id, info} = www_util.get_click_data(event.target);
            if (click_id)
                www_util.perr({id: `www_join${N}_click_${click_id}`, info});
        });
        plus_util.set_ppc_cookie();
        let plans_info = plans_util.get_plans_info(plans_util.get_plan_ids());
        let plans = Object.keys(plans_info).map(key=>{
            let {id, name, price} = plans_info[key];
            return {id, name, price, category: 'vpn-b2c',
                list: 'Plus page plans'};
        });
        eec.view_item_list(plans);
        etask(function*(){
            const _user = yield load_user();
            const page = pathname.slice(1).replace('/', '_');
            const info = {login: _user && _user.hola_uid, template:
                `join${N}`};
            perr({id: 'www_premium_visit', info});
            perr({id: `www_premium_${page}_visit`, info});
            if (plans_util.get_plan_ids().includes('free'))
                yield init_install_ctx();
            yield plus_ui.init(api, on_script_load_err);
        });
    }, []);
    plan = plans_util.get_plans_info_obj({id: state.plan_id});
    if (state.plan_id && !plan)
    {
        set_url_params({plan_id: null, plan: null});
        state.plan_id = null;
        on_qs_change();
    }
    let opt = {
        plan,
        slide: state.slide,
        coupon: state.coupon,
        user,
        provider: state.provider,
        vat_obj: state.vat_obj,
        currency: state.currency,
        set_currency: value=>set_state(_state=>({..._state,
            currency: value ? value.toUpperCase() : 'USD'})),
        user_email: _.get(user, 'emails[0].value'),
        country: (user_country||'').toLowerCase(),
        load_user,
        api,
        api_loaded,
        script_err,
        on_script_load_err,
        downloads: users_number,
        set_coupon: code=>{
            set_state(v=>({...v, coupon: code}));
        },
        set_plan: (_plan, _opt = {})=>{
            _plan = plans_util.get_discount_plan(_plan) || _plan;
            plans_util.set_plan_opt(_opt);
            perr({id: `www_join1_plan_click_${_plan.id}`});
            if (_plan.id=='free')
            {
                etask(function*(){
                    yield init_install_ctx();
                    if (iutil.need_choose_plan(install_ctx))
                        perr({id: 'www_join1_agree_show'});
                    else
                        start_install(install_ctx);
                });
                return;
            }
            plus_ui.start_checkout();
            gtm.push({event: 'choose_plan', id: _plan.id});
            set_url_params({plan: plan_to_url(_plan, _opt)});
            on_qs_change();
        },
        go_back: ()=>{
            perr({id: 'www_join1_back_click'});
            set_url_params({plan_id: null, plan: null});
            on_qs_change();
        },
        set_api: change=>set_state(_state=>{
            plus_util.api = {...plus_util.api, ...change};
            return {..._state, api: plus_util.api};
        }),
        on_continue: _opt=>{
            perr({id: 'www_join1_continue_click'});
            let next_slide = 'payment';
            if (state.slide=='account' && coupon_flow)
                next_slide = 'coupon';
            set_state(_state=>({..._state, ..._opt, slide: next_slide}));
        },
        on_method_tab_change,
        on_vat_obj_change,
    };
    const {discount_percent} = plan
        && membership.get_price_plan(plan, state.currency) || {};
    const bf_conf = hopt.www_hola.black_friday_badge_on_checkout||{};
    let cls = cn(`join_page join${N} plus_layout2`, theme.root, {
        uninstall_page: pages_dict.is_uninstall_page(),
        refund_page: ref=='refund' || ref=='refund_special_big_offer' ||
            ref=='refund_special_cta',
        black_friday_badge: bf_conf && bf_conf.enabled
            && (!bf_conf.only_for_ext || +!qs_o().bext),
        plan_selected: plan,
        only_right_part_root: only_right_part,
    }, plan && `plan_period_`+plan.period.toLowerCase().replace(' ', ''),
    discount_percent && 'plan_discount_percent_'+discount_percent);
    return <div className={cls}>
      {!only_right_part && <div
        className={cn('container plus_header', qs_o().hide_header
          && 'invisible')}>
        <Navbar_logo/>
      </div>}
      <Payment opt={opt}
        only_right_part={only_right_part}/>
      <Br_footer/>
    </div>;
};

return E;
});
